import AppHttpResource from "@/Kernel/AppHttpResource";

export default {
  job: {
    title: "Job",
    field: {
      type: "select",
      optionSource: "/app/lists/jobs",
      optionSourceHttpInstance: AppHttpResource
    },
    selected: null
  },

  station: {
    title: "Station",
    field: {
      type: "select",
      optionSource: "/app/lists/stations",
      optionSourceHttpInstance: AppHttpResource
    },
    selected: null
  }
};
